<template>
    <div class="mt-2">
        <CRow v-for="tipoDoc in tiposEncontradosTemplate" v-bind:key="tipoDoc.key">
            <CCol col="4">Utilizar Template para <span class="font-weight-bold">"{{tipoDoc.nombreTipoDoc}} {{ tipoDoc.nombreTipoDoc2 }}"</span></CCol>
            <CCol col="4">
                <span>
                    <CSwitch
                        size="sm"
                        width="150px"
                        class="align-middle mb-2"
                        shape="pill"
                        variant="outline"
                        :checked="tipoDoc.generarDocumento"
                        v-bind="{labelOn: 'Si',labelOff: 'No'}"
                        @update:checked="tipoDoc.generarDocumento = !tipoDoc.generarDocumento"
                    />  Generar Documento
                </span>
                <span v-show="tipoDoc.generarDocumento"> |
                    <CSwitch
                        size="sm"
                        v-tippy="getBaseTippy(`Generar Documento en ${tipoDoc.generarPdf ?'PDF' : 'DOC'}`)"
                        width="150px"
                        class="switchTipoDoc align-middle mb-2"
                        shape="pill"
                        variant="outline"
                        :checked="tipoDoc.generarPdf"
                        v-bind="{labelOn: 'PDF',labelOff: 'DOC'}"
                        @update:checked="tipoDoc.generarPdf = !tipoDoc.generarPdf"
                    />
                </span>
            </CCol>
            <CCol col="4" v-show="documentosTemplate.length>0">
                <multiselect
                    v-show="tipoDoc.generarDocumento"
                    class="multSelectGesto mb-2"
                    v-model="tipoDoc.templateSelected"
                    selectedLabel=""
                    deselectLabel=""
                    selectLabel=""
                    placeholder="Seleccionar Template" 
                    label="nombreDocumento" 
                    track-by="nombreDocumento"
                    :loading="loadingDocumentosTemplate"
                    :options="documentosTemplate"
                    :multiple="false">
                </multiselect>
            </CCol>
        </CRow>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
    import cons from "@/const";
    import axios from "axios";
    import apiUrls from '@/views/utils/apiUrls'
    import { format, formatDistance, formatRelative, subDays } from 'date-fns'
    import es from 'date-fns/locale/es'

    import { freeSet } from "@coreui/icons";
    import Multiselect from 'vue-multiselect'
    
    import VueModal from "@kouts/vue-modal";
    import "@kouts/vue-modal/dist/vue-modal.css";

    import DatePicker from 'vue2-datepicker';


    export default {
        name: "TiposDocumentosEncontrados",
        freeSet,
        props: {
            tiposEncontradosTemplate: Array,
            documentosTemplate: Array,
            loadingDocumentosTemplate: Boolean,


        },
        components: {
            'Modal': VueModal,
            Multiselect,
            DatePicker,
        },
        data() {
            return {
                tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
                urlBase: cons.port+"://" + cons.ipServer,
                
                


            };
        },
        created: function () {},
        beforeMount() {},
        methods: {
            
            

        },
    };
</script>

<style>
    
</style>